var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { getEnv } from "@ledgerhq/live-env";
import { BigNumber } from "bignumber.js";
const BASE_URL = getEnv("API_ALGORAND_BLOCKCHAIN_EXPLORER_API_ENDPOINT");
const NODE_URL = `${BASE_URL}/ps2/v2`;
const fullUrl = (route) => `${NODE_URL}${route}`;
export const getAccount = (network) => (address) => __awaiter(void 0, void 0, void 0, function* () {
    const { data } = yield network({
        method: "GET",
        url: fullUrl(`/accounts/${address}`),
    });
    const assets = data.assets
        ? // FIXME: what is the type of `a`?
            data.assets.map((a) => {
                return {
                    assetId: a["asset-id"].toString(),
                    balance: new BigNumber(a.amount),
                };
            })
        : [];
    return {
        round: data.round,
        address: data.address,
        balance: new BigNumber(data.amount),
        pendingRewards: new BigNumber(data["pending-rewards"]),
        assets,
    };
});
export const getTransactionParams = (network) => () => __awaiter(void 0, void 0, void 0, function* () {
    var _a;
    const { data } = yield network({
        method: "GET",
        url: fullUrl(`/transactions/params`),
    });
    return {
        fee: data["fee"],
        minFee: data["min-fee"],
        firstRound: (_a = data["first-round"]) !== null && _a !== void 0 ? _a : 0,
        lastRound: data["last-round"],
        genesisID: data["genesis-id"],
        genesisHash: data["genesis-hash"],
    };
});
export const broadcastTransaction = (network) => (payload) => __awaiter(void 0, void 0, void 0, function* () {
    const { data } = yield network({
        method: "POST",
        url: fullUrl(`/transactions`),
        data: payload,
        headers: { "Content-Type": "application/x-binary" },
    });
    return data.txId;
});
//# sourceMappingURL=algodv2.js.map